const {
	findArguments,
	makeNonmathCommandNode,
	makeMathCommandNode,
} = require("../util/ParserHelpers");

const makeParser = mathMode => {
	const makeCommandNode = mathMode
		? makeMathCommandNode
		: makeNonmathCommandNode;
	return function(ps) {
		return makeCommandNode("bottomAlign", findArguments(ps, 2));
	};
};

const bottomAlignNode = {
	draw(rc, x, y, node, measure) {
		const x1 = x;
		const y1 = y + measure.bottom - measure.firstChildBottom;
		const x2 = x + measure.firstChildWidth;
		const y2 = y + measure.bottom - measure.secondChildBottom;
		rc.drawNode(rc, x1, y1, node.children[0]);
		rc.drawNode(rc, x2, y2, node.children[1]);
	},
	measure(rc, fontInfo, props, node) {
		const m1 = rc.measureNode(rc, fontInfo, props, node.children[0]);
		const m2 = rc.measureNode(rc, fontInfo, props, node.children[1]);
		return {
			width: m1.width + m2.width,
			top: Math.max(m1.top, m2.top),
			bottom: Math.max(m1.bottom, m2.bottom),
			firstChildWidth: m1.width,
			firstChildBottom: m1.bottom,
			secondChildBottom: m2.bottom,
		};
	},
	readAloud: {children: true},
};

module.exports = {
	parsers: {
		nonmathCommands: {
			bottomalign: makeParser(false),
		},
		mathCommands: {
			bottomalign: makeParser(true),
		},
	},
	nodes: {
		bottomAlign: bottomAlignNode,
	},
};
